import { YesNo } from "@covertree/types";

export const yesNoToBoolean = (value: YesNo | string | unknown) =>
  value === YesNo.Yes;

export const booleanToYesNo = (value: boolean | undefined) =>
  value ? YesNo.Yes : YesNo.No;
